/**
 * Web app entry - serves the same shared @poker-suite/ui as Desktop.
 * Game logic will run via WASM (poker-logic compiled to wasm32) when integrated.
 */
import './index.css';
import { mountApp } from '@poker-suite/ui';

const root = document.getElementById('root');
if (root) {
  mountApp(root);
}
